
export enum RecipientDisabledSourceEnum {
    None = 0,
    EditUser = 1,
    Text = 2
}
